import { FC } from 'react';
import { useSelector } from 'frontStaticAppPath';

import professionGradeChangeButtonClick from '@hh.ru/analytics-js-events/build/career_platform/profession/profession_grade_change_button_click';
import { Tab, Tabs } from '@hh.ru/magritte-ui';
import { useSelectorNonNullable } from '@hh.ru/redux-create-reducer';
import { SPALink } from '@hh.ru/redux-spa-middleware';

import { getCurrentRouteHrefWithParam } from 'src/app/routesUtils';
import { GradeEnum } from 'src/types/grade';
import { ProfessionDescriptionGrade } from 'src/types/profession';

const NavGrades: FC = () => {
    const { profession, currentGrade } = useSelectorNonNullable((state) => state.pageProfession);
    const { location } = useSelector((state) => state.router);

    const handleTabClickTabs = (grade: ProfessionDescriptionGrade) =>
        professionGradeChangeButtonClick({
            buttonName: grade.id.toUpperCase() as GradeEnum,
        });

    return (
        // @note {key} нужен, чтобы при переходе назад состояние табов стало актуальным пусть и за счет ремаунта
        <Tabs key={currentGrade?.id} activeItemId={currentGrade ? currentGrade.id : undefined}>
            {profession.grades.map((grade) => (
                <Tab
                    mode="primary"
                    key={grade.id}
                    id={grade.id}
                    onClick={() => handleTabClickTabs(grade)}
                    Element={SPALink}
                    to={getCurrentRouteHrefWithParam(location, 'grade', grade.id)}
                    isSeoLink
                    cancelScrollCorrection
                    data-qa={`grade-tab-${grade.id}`}
                >
                    {grade.name}
                </Tab>
            ))}
        </Tabs>
    );
};

export default NavGrades;
